import React from 'react'

import { addKeyToObjectsArray } from 'utils/addUniqueKeyToObjects'
import { PEP_TYPES_MESSAGE } from 'utils/constants/pepTypes'
import { StyleSheet, Text, View } from "@react-pdf/renderer"
import { DataField } from "../../../Label"
import { formatInBrazilianDate } from "../../../../../utils/functions"
import ListItem from "../../../ListItem"
import ErrorDataText from "../../ErrorDataText"
import ContentBox from "../../../ContentBox"

const styles = StyleSheet.create({
  content: {
    marginTop: 8,
  },
})

const PepVariableReport = (props) => {
  const { pepData } = props
  try {
    return pepData.is_pep ? (
        <View>
          <DataField label="Tipo:" value={PEP_TYPES_MESSAGE[pepData?.classification]} />
          <DataField
            label="Último Status:"
            value={PEP_TYPES_MESSAGE[pepData?.last_pep_status] || "N/A"}
          />
          <DataField
            label="Início da Classificação:"
            value={pepData.start_date ? formatInBrazilianDate(pepData.start_date) : 'N/A'}
          />
          <DataField
            label="Fim da Classificação:"
            value={pepData.end_date ? formatInBrazilianDate(pepData.end_date) : 'N/A'}
          />

          <ContentBox>
            <DataField label='Classificações:' />
            <View style={styles.content}>
              {addKeyToObjectsArray(pepData.reason.map(motivo => {
                return { text: motivo }
              })).map((motivo) => (
                <ListItem key={motivo?.key}>
                  {motivo?.text}
                </ListItem>
              ))}
            </View>
          </ContentBox>
        </View>
      ) :
      (
        <Text>Não é PEP.</Text>
      )
  } catch (err) {
    return (
      <ErrorDataText exception={err} contextName='PepVariableReport' extraData={pepData} />
    )
  }
}

export default PepVariableReport

